import { get, post } from "@utils/httpUtil";

// 查询社区绑定的公众号列表
export function getNewComBindWechatList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/common/bind/wechatList`, data, config);
}

// 解绑公众号接口
export function newComBindWechatUnbind(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/common/bind/wechatUnbind`, data, config);
}

// 社区绑定微博
export function newComBindWeibo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/bind/bindWeibo`, data, config);
}

// 微博账户列表
export function getNewCommunityBindWeiboList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/weibo/getCommunityBindWeiboList`, data, config);
}

// 社区解绑微博
export function newCommunityUnbindWeibo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/bind/unbindWeibo`, data, config);
}

// 社区设置主账号
export function newCommunitySetMainAccount(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/weibo/setMainAccount`, data, config);
}
// 获取微信小程序信息列表
export function weChatMiniProgramList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/common/bind/weChatMiniProgramList`, data, config);
}

// 微信小程序解绑
export function weChatMiniProgramUnbind(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/common/bind/weChatMiniProgramUnbind`, data, config);
}
